var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseRoundLight = function SvgCloseRoundLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.472 4.472 8.943 8l3.529 3.528-.944.944L8 8.943l-3.528 3.529-.944-.944L7.057 8 3.528 4.472l.944-.944L8 7.057l3.528-3.529z"
  })));
};
export default SvgCloseRoundLight;